module.exports = __webpack_public_path__ + "img/pricing-tree-1.8061ada4.png";